<app-title-bar [title]='"Busqueda"' [icon]="'assets/img/SVG/searchIcon.svg'"></app-title-bar>
<div id="divSearch" class="search">
  <mat-tab-group [(selectedIndex)]="selectForm">
    <mat-tab label="Catastral" *ngIf="viewCatastral">
      <form class="formContainer" [formGroup]="catastralForm" (input)="inputForm($event)">
        <mat-form-field>
          <mat-label>Cédula Catastral Anterior</mat-label>
          <input matInput placeholder="Cédula Catastral Anterior" formControlName="codigo_ant" #input (keypress)="onKeyDown($event)">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Código Predial Nacional</mat-label>
          <input matInput placeholder="Código Predial Nacional" formControlName="codigo" #input (keypress)="onKeyDown($event)">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Matrícula Inmobiliaria</mat-label>
          <input matInput placeholder="Matrícula Inmobiliaria" formControlName="matricula" #input (keypress)="onKeyDown($event)">
          <mat-hint *ngIf="matriculaActiva">Sin circulo registral.</mat-hint>
        </mat-form-field>
      </form>
    </mat-tab>
    <mat-tab label="Avanzada ">
      <form class="formContainer" [formGroup]="sqlForm">
        <mat-form-field>
          <mat-label>Capa</mat-label>
          <mat-select formControlName="capa">
            <mat-optgroup *ngFor="let group of filterLayers(layers)" [label]="group.title">
              <mat-option *ngFor="let layer of group.layers" [value]="layer">
                {{layer.title}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Atributo</mat-label>
          <mat-select formControlName="atributo">
            <mat-option *ngFor="let field of sqlForm.value.capa.fields" [value]="field">
              {{field.alias}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Condición</mat-label>
          <mat-select formControlName="condicion">
            <mat-option value=">=">Mayor o igual</mat-option>
            <mat-option value=">">Mayor que</mat-option>
            <mat-option value="<">Menor que</mat-option>
            <mat-option value="<=">Menor o igual</mat-option>
            <mat-option value="=">Igual a</mat-option>
            <mat-option value="<>">Diferente</mat-option>
            <mat-option value="like">Contiene</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Valor</mat-label>
          <input matInput placeholder="Valor" formControlName="valor">
        </mat-form-field>
      </form>
    </mat-tab>
  </mat-tab-group>
  <div class="actionsButtons">
    <button mat-raised-button class="buttonAction" (click)="searchFeatures()" type="submit"
      [disabled]="!(this.sqlForm.valid || this.validCatastral)">Buscar</button>
    <button mat-raised-button class="buttonAction" (click)="clear()">Limpiar</button>
  </div>
</div>

<div *ngIf="showResultsSection">
  <div class="titleResult">
    <span id="titleResultado">Resultados: </span>
      <b *ngIf="searchResults.length === 0"> {{searchResults.length}} </b>
      <b *ngIf="searchResults.length > 0 && searchResults.length <= 1000"> {{searchResults.length}} </b>
      <b *ngIf="searchResults.length > 1000"> (>1000) </b>
  </div>
  <div id="results" class="listResults">
    <mat-progress-bar mode="indeterminate" *ngIf="progressBar"></mat-progress-bar>
    <mat-list #results style="max-height: 300px; overflow-y: auto;">
      <mat-list-item *ngFor="let result of searchResults" class="itemResult">
        {{result.layer.title}}.{{result.uid}}
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="viewAttributesFeature(result)">
            <mat-icon>table_rows</mat-icon>
            <span>Ver Atributos</span>
          </button>
          <button mat-menu-item (click)="zoomFeature(result)">
            <mat-icon>zoom_in_map</mat-icon>
            <span>Acercar</span>
          </button>
          <button mat-menu-item (click)="removeFeature(result)">
            <mat-icon>remove</mat-icon>
            <span>Limpiar Selección</span>
          </button>
        </mat-menu>
      </mat-list-item>
    </mat-list>
    <span class="noDataMessage" *ngIf="searchResults.length === 0">No se encontraron resultados con los parametros
      dados</span>
  </div>
</div>